module.exports = __webpack_public_path__ + "img/mealreminder-user-android.2bd70b84.png";